import { render, staticRenderFns } from "./ContactSourcesListPagination.vue?vue&type=template&id=38d566aa"
import script from "./ContactSourcesListPagination.vue?vue&type=script&lang=js"
export * from "./ContactSourcesListPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports